import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Card, Grid} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import ModelsTable from './modelsTable';
import {getColumns} from './modelsTableColumns';

const {
  fetchLogisticModelsList,
  updateModel,
  navigateTo,
} = Actions;

const LogisticModels = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const logisticModels = useSelector((state) => state.logisticModels.list);
  const loading = useSelector((state) => state.logisticModels.loading);
  const dispatch = useDispatch();

  const disableModel = (e, input, model) => {
    e.preventDefault();
    const data = {...model, 'status': input.checked ? 'A' : 'P'};
    dispatch(updateModel(data));
  };

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.LogisticModels, scopes.See) &&
     !hasAccessPermission(permissions, resources.LogisticModels, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fetchLogisticModelsList());
  }, [dispatch]);

  const columns = getColumns();

  return (<>
    <Card raised fluid>
      <div className='title-bar'>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <div className='title'>
                <h2>Flate Rate Modelos</h2>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Card>
    <Card raised fluid>
      <Card.Content>
        <ModelsTable tableColumns={columns} tableData={logisticModels}
          edit={{disableModel}} loading={loading} />
      </Card.Content>
    </Card>
  </>
  );
};

export default LogisticModels;
